import React from "react";

import clsx from "clsx";

import { type CategoricalBreakdownConfig } from "@north-beam/nb-common";

import { BreakdownSelector } from "../../shared";
import { type TopLevelBreakdown } from "../../types";

interface Props {
  buttonText: string;
  breakdownConfigs: CategoricalBreakdownConfig[];
  areBreakdownsSelected: boolean;
  onChange(value: TopLevelBreakdown): void;
}

export const BreakdownButtonSelect = ({
  buttonText,
  breakdownConfigs,
  areBreakdownsSelected,
  onChange,
}: Props) => (
  <BreakdownSelector
    mode="breakdowns"
    breakdownConfigs={breakdownConfigs}
    selectedBreakdowns={[]}
    buttonContentComponent={({ isOpen }) => (
      <SelectButtonContent
        isOpen={isOpen}
        variant={areBreakdownsSelected ? "icon" : "label"}
        text={buttonText}
      />
    )}
    buttonClassName={clsx("font-bold", {
      "button sm secondary-button h-7 py-0 px-2.5 border-white text-cosmic":
        !areBreakdownsSelected,
      "w-7 h-7 p-0 border border-gray rounded-full flex items-center justify-center":
        areBreakdownsSelected,
      "hover:bg-cosmic-4 hover:border-cosmic": areBreakdownsSelected,
    })}
    buttonActiveClassName={clsx({
      "button sm secondary-button h-7 py-0 px-2.5 text-white font-bold bg-cosmic":
        !areBreakdownsSelected,
      [clsx(
        "w-7 h-7 p-0 border rounded-full bg-cosmic text-white border-cosmic flex",
        "items-center justify-center",
      )]: areBreakdownsSelected,
    })}
    onSelectionChange={(values) => onChange(values[0])}
  />
);

const SelectButtonContent = ({
  isOpen,
  variant,
  text,
}: {
  isOpen: boolean;
  variant: "label" | "icon";
  text: string;
}) =>
  variant === "label" ? (
    <>{text}</>
  ) : (
    <i
      className={clsx("fa-regular fa-sharp fa-add text-xs font-bold", {
        "text-white": isOpen,
      })}
    />
  );
